import {REPORT_CLOSE_TO_FIBC_RANK} from '/enum/records.enum';

export default {
  reportName: REPORT_CLOSE_TO_FIBC_RANK,
};
